export enum ChargingMode {
  LIMITED = "LIMITED",
  UNLIMITED = "UNLIMITED",
}
